import {
  CUSTOMER_DETAIL,
  CUSTOMER_ENABLE_DISABLE,
  CUSTOMER_LIST,
  CUSTOMER_SEND_MAIL,
  CUSTOMER_VERSION_DETAIL,
  CUSTOMER_VERSION_LIST,
  FETCH_CUSTOMER_HEADQUARTER,
  SUBSCRIBER_REQUEST_DETAIL,
  SUBSCRIBER_REQUEST_LIST,
  CUSTOMER_DIVISION_LIST,
  CUSTOMER_DIVISION_FEILD_FORCE_LIST,
  CUSTOMER_ADD_DIVISION,
  CUSTOMER_DELETE_DIVISION,
  CUSTOMER_PRODUCT_OFFER_REQUEST_LIST,
  CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW,
  CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
  CUSTOMER_PRODUCT_OFFER_LIST,
  CUSTOMER_PRODUCT_OFFER_REMOVE,
  CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST,
  CUSTOMER_PRODUCT_OFFER_ADD,
  CUSTOMER_PRODUCT_OFFER_EDIT,
  PHARMACY_PRODUCT_OFFER_REQUEST_LIST,
  PHARMACY_PRODUCT_OFFER_REQUEST_VIEW,
  PRODUCT_OFFER_REQUEST_LIST,
  PRODUCT_OFFER_REQUEST_UPDATE_LIST,
  PRODUCT_OFFER_REQUEST_APPROVE_ALL,
  PRODUCT_OFFER_REQUEST_REJECT_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
  PHARMACY_PRODUCT_OFFER_LIST,
  PHARMACY_PRODUCT_OFFER_EDIT,
  PRODUCT_OFFER_VALUE,
  CUSTOMER_PHARMACY_LIST,
  CUSTOMER_PHARMACY_DETAIL,
  SUBSCRIBER_REQUEST_PHARMACY_LIST,
  SUBSCRIBER_REQUEST_PHARMACY_DETAIL,
  UPDATE_DOCTOR_TYPE,
  UPDATE_PHARMACY_TYPE,
  DOCTOR_ONBOARD_PRODUCT_LIST,
  PHARMACY_ONBOARD_PRODUCT_LIST,
  CUSTOMER_ADD_PRODUCT_LIST,
  CUSTOMER_ADD_PRODUCT_OFFER_LIST,
  ADD_CUSTOMER_PRODUCT,
  ADD_PHARMACY_PRODUCT,
  CUSTOMER_SUBSCRIBER_REQUEST_LIST,
  CUSTOMER_SUBSCRIBER_REQUEST_DETAIL,
} from "./types";

export const linkedCustomerList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const linkedCustomerDetail = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const linkedPharmacyList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PHARMACY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const linkedPharmacyDetail = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PHARMACY_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const subscriberRequestList = (data, onSuccess, onError) => {
  return {
    type: SUBSCRIBER_REQUEST_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const subscriberRequestDetail = (id, onSuccess, onError) => {
  return {
    type: SUBSCRIBER_REQUEST_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const subscriberRequestPharmacyList = (data, onSuccess, onError) => {
  return {
    type: SUBSCRIBER_REQUEST_PHARMACY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const subscriberRequestPharmacyDetail = (id, onSuccess, onError) => {
  return {
    type: SUBSCRIBER_REQUEST_PHARMACY_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const customerVersionList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerVersionDetial = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_VERSION_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const customerApproveReject = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_ENABLE_DISABLE,
    data,
    onSuccess,
    onError,
  };
};
export const fetchCustomerHeadQuatrer = (id, onSuccess, onError) => {
  return {
    type: FETCH_CUSTOMER_HEADQUARTER,
    id,
    onSuccess,
    onError,
  };
};
export const customerSendMail = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_SEND_MAIL,
    data,
    onSuccess,
    onError,
  };
};
export const customerDivisionList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_DIVISION_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const customerDivisionFeildForceList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_DIVISION_FEILD_FORCE_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const customerAddDivision = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_ADD_DIVISION,
    data,
    onSuccess,
    onError,
  };
};
export const customerDeleteDivision = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_DELETE_DIVISION,
    data,
    onSuccess,
    onError,
  };
};

export const customerProductOfferRequestList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_REQUEST_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const pharmacyProductOfferRequestList = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_REQUEST_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerProductOfferRequestView = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyrProductOfferRequestView = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_REQUEST_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const productOfferRequestList = (data) => {
  return {
    type: PRODUCT_OFFER_REQUEST_LIST,
    data,
  };
};

export const productOfferRequestUpdateList = (data) => {
  return {
    type: PRODUCT_OFFER_REQUEST_UPDATE_LIST,
    data,
  };
};

export const productOfferValue = (data) => {
  return {
    type: PRODUCT_OFFER_VALUE,
    data,
  };
};

export const ProductOfferRequestApproveAll = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_OFFER_REQUEST_APPROVE_ALL,
    data,
    onSuccess,
    onError,
  };
};

export const ProductOfferRequestRejectAll = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_OFFER_REQUEST_REJECT_ALL,
    data,
    onSuccess,
    onError,
  };
};

export const PharmacyProductOfferRequestApproveAll = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL,
    data,
    onSuccess,
    onError,
  };
};

export const PharmacyProductOfferRequestRejectAll = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL,
    data,
    onSuccess,
    onError,
  };
};

export const customerProductOfferRequestApproveReject = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyProductOfferRequestApproveReject = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
    data,
    onSuccess,
    onError,
  };
};

export const customerProductOfferList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyProductOfferList = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerProductOfferDivisionProductsList = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerRemoveProductOffer = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_REMOVE,
    data,
    onSuccess,
    onError,
  };
};

export const customerAddProductOffer = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const customerEditProductOffer = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_PRODUCT_OFFER_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyEditProductOffer = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_PRODUCT_OFFER_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const updateDoctorType = (data, onSuccess, onError) => {
  return {
    type: UPDATE_DOCTOR_TYPE,
    data,
    onSuccess,
    onError,
  };
};
export const updatePharmacyType = (data, onSuccess, onError) => {
  return {
    type: UPDATE_PHARMACY_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const doctorOnboardProductList = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_ONBOARD_PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const parmacyOnboardProductList = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_ONBOARD_PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerAddProductList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_ADD_PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const customerAddProductOfferList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_ADD_PRODUCT_OFFER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addCustomerProduct = (data, onSuccess, onError) => {
  return {
    type: ADD_CUSTOMER_PRODUCT,
    data,
    onSuccess,
    onError,
  };
};
export const addPharmacyProduct = (data, onSuccess, onError) => {
  return {
    type: ADD_PHARMACY_PRODUCT,
    data,
    onSuccess,
    onError,
  };
};
export const customerSubscriberRequestList = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_SUBSCRIBER_REQUEST_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customerSubscriberRequestDetail = (id, onSuccess, onError) => {
  return {
    type: CUSTOMER_SUBSCRIBER_REQUEST_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
